import createPrintable from '../createPrintable';
import minimallyProcessedPhaseOne from './minimallyProcessedPhaseOne.png'
import phaseOneChiaPrintout from '../../stories/phaseOne/phaseOneChiaPrintout.JPG'

const shortName="phaseOneChia"
const title = "Phase One - Eat Chia Seeds"
const description="This printout is for phase one - easing into a daily chia seed routine. Print or save the image digitally, then begin to follow the daily guidelines for how much chia to make. You can write your start date in the upper-left-hand box, then add dates for each “day” going forward. After you complete each day, color it in or use a sticker to celebrate your success!"
const src=minimallyProcessedPhaseOne
const alt="5 x 7 printout with Minimally Processed Phase One Chia Seeds on top, with a large two column rectangle grid for week 1 and week 2 of chia tracking"
const displaySrc=phaseOneChiaPrintout
const displayAlt="table display of the printout, with days 1-9 colored in various green colors"

const chiaTips = createPrintable (shortName, title, description, src, alt, displaySrc, displayAlt)

export default chiaTips;